import type {BtnGroupTabItem} from "~/components/BtnGroupTabs/BtnGroupTabs";
import DangerIcon from "~/icons/svg/DangerIcon.svg?react";
import ShieldIcon from "~/icons/svg/ShieldIcon.svg?react";
import ChartIcon from "~/icons/svg/ChartIcon.svg?react";
import NoteIcon from "~/icons/svg/NoteIcon.svg?react";
import InfoIcon from "~/icons/svg/InfoIcon.svg?react";
import TransactionIcon from "~/icons/svg/TransactionIcon.svg?react";
import ValueChainIcon from "~/icons/svg/ValueChainIcon.svg?react";

/** The landing tab: every redirect falls back to it, so it can never be hidden. */
export const SUPPLIER_DETAIL_HOME_TAB = 'overview';

/** The supplier detail page's tabs, in order; `route` is the URL segment (and the key in the hidden-tabs setting). */
export const SUPPLIER_DETAIL_TABS: (BtnGroupTabItem & {route: string})[] = [
    {title: 'Overview', Icon: InfoIcon, route: SUPPLIER_DETAIL_HOME_TAB},
    {title: 'Transactions', Icon: TransactionIcon, route: 'transactions'},
    {title: 'Contracts', Icon: NoteIcon, route: 'contracts'},
    {title: 'Opportunities', Icon: ChartIcon, route: 'opportunities'},
    {title: 'Compliance', Icon: ShieldIcon, route: 'compliance'},
    {title: 'Insights', Icon: DangerIcon, route: 'insights'},
    {title: 'Value chain', Icon: ValueChainIcon, route: 'value-chain'},
];
